import React from "react";
import PropTypes from "prop-types";
import { Paper, withStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useSelectPermission } from "../../../../hooks";
import { Tipografia } from "../../../../_common";
import ReadMore from "../../../../_common/components/ReadMore/ReadMore";
import { ExcluirAtividade } from "../../../atividade/components";
import { EditarAtividadeButton } from "../../../atividade/components/EditarAtividade";
import { ConcluirAtividadeButton } from "../../../atividade/components/ConcluirAtividade";
import permissions from "../../../../_common/permissions";
import { ACCESS_LEVEL, NU_TIPO_ATIVIDADE_ID } from "../../../../_common/constantes";

const styles = {
  textoEvento: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    padding: "8px 8px 8px 8px",
    "&:hover $divAcao": {
      display: "block",
      alignSelf: "flex-end",
      marginTop: -8,
    },
  },
  texto: { whiteSpace: "pre-line", paddingBottom: 5 },
  textoResponsavel: { whiteSpace: "pre-line", paddingBottom: 5 },
  textoContato: {
    paddingBottom: 3,
  },
  textoObservacao: {
    paddingTop: 5,
    paddingBottom: 3,
    overflowWrap: "break-word",
  },
  divAcao: {
    display: "none",
    position: "absolute",
  },
  botaoIcone: {
    width: 32,
    height: 32,
    padding: 4,
  },
  icone: {
    width: 16,
    height: 16,
  },
  iconEditar: {
    width: "16px",
    heigth: "16px",
    marginTop: "-8px",
  },
};

const TimeLineItemAtividade = ({
  atividade,
  callback,
  handleConcluirAtividade,
  handleEditarAtividade,
  usuarioLogado,
  isTimelineAtividades,
  classes,
}) => {
  const intl = useIntl();
  const permissaoAtividade = useSelectPermission(permissions.MODULOATIVIDADES);

  function obterTextoDescricao() {
    const descricao =
      atividade.nuTipoAtividade === NU_TIPO_ATIVIDADE_ID.OUTROS
        ? `${atividade.tituloEvento}: ${atividade.texto.split(":")[0]}`
        : atividade.tituloEvento;
    return descricao;
  }

  return (
    <Paper className={classes.textoEvento} zDepth={1} elevation={isTimelineAtividades ? 0 : 1}>
      <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.textoResponsavel}>
        {atividade.responsavel}
      </Tipografia>
      <Tipografia className={classes.texto}>{obterTextoDescricao()}</Tipografia>

      {!isTimelineAtividades &&
        (atividade.preVendedorId === usuarioLogado.id ||
          usuarioLogado.isGerente ||
          (permissaoAtividade && permissaoAtividade.nivelAcesso === ACCESS_LEVEL.COMPLETE)) && (
          <div className={classes.divAcao}>
            <ExcluirAtividade
              id={atividade.atividadeId}
              styleIcon={styles.iconEditar}
              callback={resp => resp && callback(callback)}
            />
            {!atividade.FlConclusao && (
              <EditarAtividadeButton
                styleIcon={styles.iconEditar}
                onClick={handleEditarAtividade}
                title={intl.formatMessage({ defaultMessage: "Editar Atividade" })}
              />
            )}
            {!usuarioLogado.isGerente &&
              !atividade.FlConclusao && (
                <ConcluirAtividadeButton
                  styleIcon={styles.iconEditar}
                  onClick={handleConcluirAtividade}
                  title={intl.formatMessage({ defaultMessage: "Concluir Atividade" })}
                />
              )}
          </div>
        )}
      {!isTimelineAtividades &&
        atividade.nomeContatos && (
          <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.textoContato}>
            {atividade.nomeContatos}
          </Tipografia>
        )}

      {!isTimelineAtividades &&
        atividade.observacao && (
          <ReadMore lines={2} TipografiaProps={{ tipo: "notaLegendas", cor: "darkSecondaryText" }}>
            <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.textoObservacao}>
              {atividade.observacao}
            </Tipografia>
          </ReadMore>
        )}
    </Paper>
  );
};

TimeLineItemAtividade.propTypes = {
  atividade: PropTypes.object,
  usuarioLogado: PropTypes.object,
  handleConcluirAtividade: PropTypes.func,
  handleEditarAtividade: PropTypes.func,
  callback: PropTypes.func,
  classes: PropTypes.object,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimeLineItemAtividade);
